var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M821 431L821 459",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 821.5,
    cy: 426.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M818.105 435C817.637 435 817.236 434.834 816.903 434.501C816.57 434.168 816.403 433.768 816.403 433.3C816.403 432.833 816.57 432.432 816.903 432.099C817.236 431.766 817.637 431.6 818.105 431.6C818.573 431.6 818.973 431.766 819.306 432.099C819.64 432.432 819.806 432.833 819.806 433.3C819.806 433.768 819.64 434.168 819.306 434.501C818.973 434.834 818.573 435 818.105 435ZM826.613 435C826.145 435 825.744 434.834 825.411 434.501C825.078 434.168 824.911 433.768 824.911 433.3C824.911 432.833 825.078 432.432 825.411 432.099C825.744 431.766 826.145 431.6 826.613 431.6C827.081 431.6 827.481 431.766 827.814 432.099C828.148 432.432 828.314 432.833 828.314 433.3C828.314 433.768 828.148 434.168 827.814 434.501C827.481 434.834 827.081 435 826.613 435ZM817.382 421.4L819.423 425.65H825.379L827.719 421.4H817.382ZM816.573 419.7H829.122C829.449 419.7 829.697 419.845 829.867 420.136C830.037 420.426 830.044 420.72 829.888 421.018L826.868 426.457C826.712 426.741 826.503 426.96 826.24 427.116C825.978 427.272 825.691 427.35 825.379 427.35H819.041L818.105 429.05H828.314V430.75H818.105C817.467 430.75 816.985 430.47 816.658 429.911C816.332 429.351 816.318 428.795 816.616 428.242L817.764 426.16L814.702 419.7H813V418H815.765L816.573 419.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.27cfad87298bc974658ca01a47f4cc51.svg";
export { ForwardRef as ReactComponent };